import { Component, DestroyRef, Inject, inject, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { cloneDeep } from 'lodash';
import { AcrReportingPeriod } from '@shared/models/acr-reporting-period.model';
import { AcrProjectService } from '@core/api/acr-project.service';
import { SpinnerService } from '@shared/spinner/spinner.service';
import { ToastService } from '@shared/services/toast.service';
import moment from "moment/moment";
import { FormatHelperService } from '@core/helper/format-helper.service';

@Component({
  selector: 'fc-dialog-edit-reporting-period',
  templateUrl: './dialog-edit-reporting-period.component.html',
  styleUrl: './dialog-edit-reporting-period.component.scss',
  standalone: false
})
export class DialogEditReportingPeriodComponent implements OnInit {
  destroyRef = inject(DestroyRef);
  updateForm: UntypedFormGroup;
  period: AcrReportingPeriod;

  constructor(
    readonly dialogRef: MatDialogRef<DialogEditReportingPeriodComponent>,
    readonly dialog: MatDialog,
    readonly formBuilder: UntypedFormBuilder,
    readonly formatHelper: FormatHelperService,
    readonly acrProjectService: AcrProjectService,
    readonly spinnerService: SpinnerService,
    readonly toastService: ToastService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.period = cloneDeep(data.reportingPeriod);
  }

  ngOnInit(): void {
    let groups = {
      foliumId: [this.period.foliumId, Validators.required],
      endDate: moment(this.period.endDate, true).toDate(),
      verificationDate: this.period.verificationDate ? moment(this.period.verificationDate, true).toDate() : '',
      verificationNotes: this.period.verificationNotes,
      issuanceDate: this.period.issuanceDate ? moment(this.period.issuanceDate, true).toDate() : '',
      verificationIssuance: this.period.verificationIssuance,
    }
    this.period.vintages.forEach(vintage => {
      groups[`vintage_${vintage.vintageYear}_expected`] = vintage.expectedIssuance;
      groups[`vintage_${vintage.vintageYear}_actual`] = vintage.actualIssuance;
    })
    this.updateForm = this.formBuilder.group(groups);
  }

  onNoClick(): void {
    this.dialogRef.close(null);
  }

  onSubmit() {
    this.spinnerService.show('app-spinner', "Updating Reporting Period...");
    let vintageUpdates = [];
    this.period.vintages.forEach(vintage => {
      vintage.expectedIssuance = this.updateForm.controls[`vintage_${vintage.vintageYear}_expected`].value;
      vintage.actualIssuance = this.updateForm.controls[`vintage_${vintage.vintageYear}_actual`].value;
      vintageUpdates.push(vintage);
    })
    this.acrProjectService.updateReportingPeriod(this.period.acrProjectId, this.period.id, {
      foliumId: this.updateForm.controls.foliumId.value,
      endDate: new Date(this.updateForm.controls.endDate.value).getTime() / 1000,
      verificationDate: this.updateForm.controls.verificationDate.value ? new Date(this.updateForm.controls.verificationDate.value).getTime() / 1000 : null,
      verificationNotes: this.updateForm.controls.verificationNotes.value,
      issuanceDate: this.updateForm.controls.issuanceDate.value ? new Date(this.updateForm.controls.issuanceDate.value).getTime() / 1000 : null,
      verificationIssuance: this.updateForm.controls.verificationIssuance.value,
      vintages: vintageUpdates,
    }).subscribe({
      next: () => {
        this.dialogRef.close(true);
        this.spinnerService.hide('app-spinner');
      },
      error: () => {
        this.spinnerService.hide('app-spinner');
      }
    });
  }
}
